import { Link } from 'react-router-dom';
import { Col, Typography } from 'antd';
import { Product } from '../apollo/api';
import BookCover from './BookCover';

export default function LibraryItem(p: { product: Pick<Product, 'id' | 'img_url' | 'description'> }) {
  return (
    <Link to={(location) => `${location.pathname}/${p.product.id}`} key={p.product.id}>
      <Col className="Library-item">
        <BookCover
          url={p.product.img_url}
          wrapperClassName="Library-item-cover-container"
          className="Library-item-cover"
        />
        <Typography.Paragraph ellipsis={{ rows: 3 }} className="Library-item-title">
          <span dangerouslySetInnerHTML={{ __html: p.product.description ?? '' }} />
        </Typography.Paragraph>
      </Col>
    </Link>
  );
}
